export default __webpack_public_path__ + "static/media/12.541b5d8e.jpg";